import type { ConfigType } from '@lotta/self-service/lottery-fe/util-config';
import { ConfigContext } from '@lotta/self-service/lottery-fe/util-config';
import { Outlet } from 'react-router-dom';
import { environment } from '../environments/environment';

export const Config: React.FC = () => {
  const { ikeaDomain, customerAdminDomain } = environment;
  const config: ConfigType = {
    ikeaDomain,
    customerAdminDomain,
  };
  return (
    <ConfigContext.Provider value={config}>
      <Outlet />
    </ConfigContext.Provider>
  );
};
